import axios from 'axios'

class UsuarioApiClient {

    async buscarLogado(produtoId) {
        return await axios.get(`/hal/usuario/sessao?produtoId=${produtoId}`)
    }

    async buscarDominioPerfil(usuarioId, perfilTipo) {
        return await axios.get(`/hal/dominio/${usuarioId}?perfilTipo=${perfilTipo}&produtoId=300`)
    }

    async atualizarSessaoDominio(dominioClienteId, dominioTipo) {
        return await axios.put(`/hal/usuario/sessao/atualizarSessao?dominioIdCliente=${dominioClienteId}&dominioTipoCliente=${dominioTipo}`)
    }

    async editar(payload) {
        return await axios.post('/hal/editarUsuario', payload)
    }
}

export default new UsuarioApiClient()
